import { render, staticRenderFns } from "./disUser.vue?vue&type=template&id=249035d9"
import script from "./disUser.vue?vue&type=script&lang=js"
export * from "./disUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports